import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { TooltipProvider } from '~shared/shadcn/ui/tooltip';

import { queryClient } from '../query-client';

export const Providers = ({ children }: { children: React.ReactNode }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools buttonPosition='bottom-left' />
      <TooltipProvider>{children}</TooltipProvider>
    </QueryClientProvider>
  );
};
